const wdTradeInDataCache = {};
const wdTradeInDataPending = {};
window.wdFetchTradeInCollectionData_cache = function (collectionHandle) {
    const handle = (collectionHandle || window.wdTradeInCollectionHandle || '').trim();
    return wdTradeInDataCache[handle];
};

window.wdFetchTradeInCollectionData = async function (collectionHandle) {
    const handle = (collectionHandle || window.wdTradeInCollectionHandle || '').trim();
    if (!handle) {
        return { products: [], highestValueAmount: 0 };
    }

    if (wdTradeInDataCache[handle]) return wdTradeInDataCache[handle];
    if (wdTradeInDataPending[handle]) return wdTradeInDataPending[handle];

    wdTradeInDataPending[handle] = (async () => {
        try {
            const response = await fetch(
            `${window.location.origin}/apps/api/products/trade-in/${encodeURIComponent(handle)}`
            );

            if (!response.ok) {
                throw new Error(`Trade-in products request failed (${response.status})`);
            }

            const payload = await response.json();

            if (!payload?.success || !payload?.data) {
                throw new Error('Trade-in products response is invalid');
            }

            wdTradeInDataCache[handle] = payload.data;
            return payload.data;
        } catch (error) {
            console.error('Failed to load trade-in collection products:', error);
            return { products: [], highestValueAmount: 0 };
        } finally {
            delete wdTradeInDataPending[handle];
        }
    })();

    return wdTradeInDataPending[handle];
};
